export default __webpack_public_path__ + "static/media/logo_default-dark-bg.b9b3c2b3.svg";